import { render, staticRenderFns } from "./ResWire.vue?vue&type=template&id=4aa5fbb4&scoped=true"
import script from "./ResWire.vue?vue&type=script&lang=js"
export * from "./ResWire.vue?vue&type=script&lang=js"
import style0 from "./ResWire.vue?vue&type=style&index=0&id=4aa5fbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5fbb4",
  null
  
)

export default component.exports